import member from '@/views/setting/views/member/member';
export default member;